module.exports = {
  require:
    ngModel: 'ngModel'
  template: require('./date-time-input.pug')()
  controller: require('./date-time-input.ctrl')
  bindings:
    label: '@'
    showTimeFlag: '<'
}
